module.exports = __webpack_public_path__ + "img/b-vreesmachine.34944022.jpg";